import React from 'react'

export default function GuideCompContainer(props) {
  return (
    <div class="multi-tips-item">
        <div class="multi-tips-img">
        <img src={props.image} alt="checklist" />
        {props.bluetoothCheckMsg && <img src={props.image2} alt="checklist" />}
        </div>
        <div class="multi-tips-body">
            <p class="heading" dangerouslySetInnerHTML={{__html: props.heading}}></p>
            <p dangerouslySetInnerHTML={{__html: props.text}}></p>
            <p class="subtext" dangerouslySetInnerHTML={{__html: props.subText}}></p>
        </div>
    </div>
  )
}
